import React from "react";

const Compose: React.FC = () => {
    return (
        <div className="flex items-center flex-grow px-2">
            <div className="flex relative flex-grow mx-2">
                <div className="h-11 text-base rounded-full pl-5 pr-5 shadow flex-grow pt-2.5 bg-opacity-100 bg-white">Send a message</div>
            </div>
            <button
                style={{
                    backgroundColor: "#075e54",
                }}
                disabled
                aria-label="preview send"
                className="flex items-center justify-center text-white rounded-full h-10 w-10 shadow"
            >
                <i className="flex">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
                        <path fill="currentColor" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z" />
                    </svg>
                </i>
            </button>
        </div>
    );
};

export default Compose;
